import { LucideIcon } from "@ews-admin/global-design-system";
import React from "react";

export interface StatisticsCardProps {
  title: string;
  value: string | number;
  subtitle?: string;
  icon?: LucideIcon;
  iconColor?: string;
  iconBgColor?: string;
  borderColor?: string;
  trend?: {
    value: string;
    isPositive: boolean;
  };
  className?: string;
}

export const StatisticsCard: React.FC<StatisticsCardProps> = ({
  title,
  value,
  subtitle,
  icon: Icon,
  iconColor = "text-ews-primary",
  iconBgColor = "bg-primary-100",
  borderColor = "border-ews-primary",
  trend,
  className = "",
}) => {
  return (
    <div className={`border-l-4 card-container ${borderColor} ${className}`}>
      <div className="flex justify-between items-center">
        <div>
          <p className="text-sm font-medium text-neutral-600">{title}</p>
          <p className="text-2xl font-semibold text-neutral-900">{value}</p>
        </div>
        {Icon && (
          <div
            className={`flex justify-center items-center w-12 h-12 rounded-full ${iconBgColor}`}
          >
            <Icon className={`w-6 h-6 ${iconColor}`} />
          </div>
        )}
      </div>
      {(subtitle || trend) && (
        <div className="flex gap-2 items-center mt-4 text-sm">
          {subtitle && (
            <span className="font-medium text-success-500">{subtitle}</span>
          )}
          {trend && (
            <span
              className={`font-medium ${
                trend.isPositive ? "text-success-500" : "text-danger-500"
              }`}
            >
              {trend.value}
            </span>
          )}
        </div>
      )}
    </div>
  );
};
